import * as TimePeriod from './time-period';
import * as Actions from './actions';

import options from './alerts-actions-content.component';

const Component = {
    selector: 'dtAlertsActionsContent',
    options
};

export {
    Component,
    Actions,
    TimePeriod
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/index.js